import { useQuery } from '@tanstack/react-query';
import { transport } from '@opengov/app-core/transport';

import { ICurrentOrLegacySavedViewInfo } from '../../../../types';
import { useToast } from '../../../../stories/components/Toast/context/useToast.context';
import { embedPickerQueryKeys, SavedViewInfoKeyParams } from './embedPickerQueryKeys';

export type UseSavedViewInfoParams = SavedViewInfoKeyParams | null;

// Fetches visualization metadata (defaultType/visualizations/fiscalYears/hasAnnualDataOnly)
// for the selected saved view. Pass null to disable (no saved view selected).
export function useSavedViewInfo(params: UseSavedViewInfoParams) {
  const { toggleToast } = useToast();

  return useQuery<ICurrentOrLegacySavedViewInfo, Error>({
    queryKey: params
      ? embedPickerQueryKeys.savedViewInfo(params)
      : ([...embedPickerQueryKeys.all, 'savedViewInfo', 'disabled'] as const),
    queryFn: async (): Promise<ICurrentOrLegacySavedViewInfo> => {
      if (!params) throw new Error('Disabled');
      return transport
        .url(`/api/embed_crud_service/v2/info/saved_view/${params.savedViewId}`)
        .get()
        .json();
    },
    enabled: params !== null,
    onError: () => {
      toggleToast({ title: 'Could not load saved view info', severity: 'error' });
    }
  });
}
